
import Vue from "vue"
import Component from "vue-class-component"
import {QBtn} from "quasar"
import {Prop} from "vue-property-decorator"

@Component({components: {QBtn}})
export default class AddDeleteButton extends Vue {
  @Prop({default: false})
  add: boolean

  @Prop({default: null})
  tooltip: string | null

  @Prop({default: false})
  disable: boolean
}
